export default ({ id }) => ({
  inputEl: null,

  init() {
    this.inputEl = document.getElementById(id)
    // Re-render progress UI on the next tick
    // due to Alpine JS initial input value handling
    setTimeout(() => this.renderProgress())
  },

  handleChange($event, callback) {
    this.renderProgress()
    callback($event)
  },

  renderProgress() {
    const value = Number(this.inputEl.value)
    const min = Number(this.inputEl.min)
    const max = Number(this.inputEl.max)
    const progress = ((value - min) / (max - min)) * 100

    this.inputEl.style.background = `linear-gradient(to right, #29ABE2 ${progress}%, #AEDFF4 ${progress}%)`
  },
})
